<template>
  <div>
    <div>
      <div class="pt-md-16">
        <v-container>
          <v-row class="mx-md-0">
            <v-col cols="12" class="pa-0">
              <HCarCard :car="car" @click="mainImageClicked" />
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div v-if="car">
        <div class="py-md-6">
          <v-container>
            <div
              class="mb-md-4"
              :class="
                isLargeScreen ? 'text-h5 font-weight-regular' : 'text-subtitle-1 font-weight-medium'
              "
            >
              Gallery
            </div>
            <v-row class="my-2 mx-md-0">
              <v-col
                v-for="(image, key) in images"
                :key="key"
                cols="12"
                lg="2"
                style="padding: 1px;"
              >
                <v-img
                  v-if="isLargeScreen"
                  @click="viewImage(key)"
                  style="cursor: pointer"
                  :src="image.thumbnailSrc"
                  :aspect-ratio="1"
                ></v-img>
                <v-img v-else :src="image.src"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <image-viewer :images="car.images" v-model="viewImageIndex" />
      </div>
    </div>
  </div>
</template>

<script>
import { getFirestore, doc, getDoc } from "firebase/firestore/lite"

import HCarCard from "../components/HCarCard.vue"
import ImageViewer from "../components/ImageViewer.vue"

export default {
  components: { HCarCard, ImageViewer },
  props: ["carid"],

  data() {
    return {
      car: null,
      viewImageIndex: null,
    }
  },

  mounted() {
    this.getCar()
  },

  computed: {
    isLargeScreen() {
      return this.$vuetify.breakpoint.lgAndUp
    },
    images() {
      const imgs = { ...this.car.images }
      delete imgs.main
      return imgs
    },
  },

  methods: {
    mainImageClicked() {
      this.viewImageIndex = "main"
    },
    async getCar() {
      // TODO: check if it's no longer available (sold)

      const carRef = doc(getFirestore(), "cars", this.carid)

      const carDoc = await getDoc(carRef)
      this.car = carDoc.data()
    },

    viewImage(key) {
      this.viewImageIndex = key
    },
  },
}
</script>
